/** URL-safe slug for a blog tag: "Fabric Care" -> "fabric-care". */
export function tagSlug(tag: string): string {
  return String(tag)
    .toLowerCase()
    .trim()
    .replace(/['".]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Human label for a tag slug: "fabric-care" -> "Fabric Care". */
export function tagLabel(slug: string): string {
  return slug
    .split("-")
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(" ");
}
